<template>
	<div class="searchGroup">
		<div class="operationRow">
			<div class="btn-left">
				<slot name="operation-left" />
			</div>
			<div class="btn-right">
				<a-input-group
					compact
					class="default-search"
					v-for="item in defaultSearch"
					:key="item.value"
				>
					<slot name="default-search" v-if="$slots['default-search']" />
					<template v-else>
						<template v-if="item.type === 'input'">
							<a-input
								:disabled="visible"
								v-model.trim="searchForm[item.value]"
								:placeholder="`请输入${item.label}`"
								allowClear
								v-bind="item.config"
								v-on="item.on"
							/>
						</template>
						<template v-if="item.type === 'select'">
							<a-select
								v-model="searchForm[item.value]"
								:disabled="visible"
								:placeholder="
									item.placeholder ? item.placeholder : `请选择${item.label}`
								"
								v-bind="item.config"
								v-on="item.on"
							>
								<a-select-option
									v-for="it in item.options"
									:key="
										item.config &&
										item.config.fieldNames &&
										item.config.fieldNames.value
											? it[item.config.fieldNames.value]
											: it.value
									"
									:value="
										item.config &&
										item.config.fieldNames &&
										item.config.fieldNames.value
											? it[item.config.fieldNames.value]
											: it.value
									"
								>
									{{
										item.config &&
										item.config.fieldNames &&
										item.config.fieldNames.label
											? it[item.config.fieldNames.label]
											: it.label
									}}
								</a-select-option>
							</a-select>
						</template>
						<template v-if="item.type === 'rangePicker'">
							<a-range-picker
								:format="
									item.config?.format !== undefined
										? item.config.format
										: 'YYYY-MM-DD HH:mm:ss'
								"
								v-model="searchForm[item.value]"
								:disabled="visible"
								:placeholder="
									item.placeholder ? item.placeholder : ['开始时间', '结束时间']
								"
								v-bind="item.config"
								v-on="item.on"
								:show-time="
									item.config?.showTime !== undefined
										? item.config?.showTime
										: {
												defaultValue: moment(['00:00:00', 'HH:mm:ss']),
										  }
								"
							/>
						</template>
						<template v-if="item.type === 'datePicker'">
							<a-date-picker
								v-model="searchForm[item.value]"
								:disabled="visible"
								:placeholder="
									item.placeholder ? item.placeholder : '选择日期时间'
								"
								v-bind="item.config"
							/>
						</template>

						<template v-if="item.type === 'cascader'">
							<a-cascader
								:options="item.options"
								:disabled="visible"
								v-model="searchForm[item.value]"
								:placeholder="
									item.placeholder ? item.placeholder : `请选择${item.label}`
								"
								v-bind="item.config"
							></a-cascader>
						</template>
						<template v-if="item.type === 'treeSelect'">
							<a-treeSelect
								v-model="searchForm[item.value]"
								:disabled="visible"
								:placeholder="
									item.placeholder ? item.placeholder : `请选择${item.label}`
								"
								v-bind="item.config"
								v-on="item.on"
								:treeData="item.options"
							></a-treeSelect>
						</template>
						<template v-if="item.type === 'multipleSelect'">
							<a-select
								class="type"
								v-model="searchForm[item.value]['type']"
								:options="item.typeOptions"
								@change="e => changeItemType(e, item.value)"
								v-bind="item.config"
							/>
							<template v-if="searchForm[item.value]['type'] === 'IN'">
								<a-select
									:disabled="visible"
									mode="tags"
									allowClear
									:token-separators="[',', '\n', ' ', '，']"
									:placeholder="`请输入${item.label}`"
									v-model="searchForm[item.value]['value']"
									:maxTagCount="1"
									:maxTagTextLength="5"
								/>
							</template>
							<template
								v-else-if="
									searchForm[item.value]['type'] === 'BETWEEN' &&
									Array.isArray(searchForm[item.value]['value'])
								"
							>
								<a-input
									:disabled="visible"
									v-model.trim="searchForm[item.value]['value'][0]"
									:placeholder="`${item.label}区间值`"
								/>
								~
								<a-input
									:disabled="visible"
									v-model.trim="searchForm[item.value]['value'][1]"
									:placeholder="`${item.label}区间值`"
								/>
							</template>
							<template v-else>
								<a-input
									:disabled="visible"
									v-model.trim="searchForm[item.value]['value']"
									:placeholder="`请输入${item.label}`"
								/>
							</template>
						</template>
						<template v-if="item.type === 'slot'">
							<slot
								:name="item.value"
								v-bind="{
									searchForm,
									config: item,
								}"
							/>
						</template>
					</template>

					<a-button
						v-if="item.value"
						type="primary"
						icon="search"
						style="font-size: 16px"
						theme=""
						@click="onSearch"
					></a-button>
				</a-input-group>

				<a-button @click="visible = !visible">
					<yw-icon iconClass="xian16-gaojisousuo1" />高级搜索
				</a-button>
				<a-tooltip>
					<a-button icon="reload" @click="handleclick" />
					<template slot="title"> 重置 </template>
				</a-tooltip>
				<slot name="operation-right" />
			</div>
		</div>
		<div style="width: 100%; overflow: auto">
			<a-form-model v-show="visible" :model="searchForm" class="searchForm">
				<a-row :gutter="24" style="max-height: 500px; overflow: auto">
					<template v-for="item in list">
						<a-col :span="24 / columns" :key="item.value">
							<a-form-model-item
								:class="{ multipleSelect: item.type === 'multipleSelect' }"
							>
								<template v-if="item.type === 'input'">
									<a-input
										v-model.trim="searchForm[item.value]"
										:addonBefore="item.label"
										:placeholder="
											item.placeholder
												? item.placeholder
												: `请输入${item.label}`
										"
										v-bind="item.config"
										v-on="item.on"
									></a-input>
								</template>
								<template v-if="item.type === 'select'">
									<label>{{ item.label }}</label>
									<a-select
										v-model="searchForm[item.value]"
										:placeholder="
											item.placeholder
												? item.placeholder
												: `请选择${item.label}`
										"
										v-bind="item.config"
										v-on="item.on"
									>
										<a-select-option
											v-for="it in item.options"
											:key="
												item.config &&
												item.config.fieldNames &&
												item.config.fieldNames.value
													? it[item.config.fieldNames.value]
													: it.value
											"
											:value="
												item.config &&
												item.config.fieldNames &&
												item.config.fieldNames.value
													? it[item.config.fieldNames.value]
													: it.value
											"
										>
											{{
												item.config &&
												item.config.fieldNames &&
												item.config.fieldNames.label
													? it[item.config.fieldNames.label]
													: it.label
											}}
										</a-select-option>
									</a-select>
								</template>
								<template v-if="item.type === 'rangePicker'">
									<label>{{ item.label }}</label>
									<a-range-picker
										:format="
											item.config?.format !== undefined
												? item.config.format
												: 'YYYY-MM-DD HH:mm:ss'
										"
										v-model="searchForm[item.value]"
										:placeholder="
											item.placeholder
												? item.placeholder
												: ['开始时间', '结束时间']
										"
										v-bind="item.config"
										v-on="item.on"
										:show-time="
											item.config?.showTime !== undefined
												? item.config?.showTime
												: {
														defaultValue: moment(['00:00:00', 'HH:mm:ss']),
												  }
										"
									/>
								</template>
								<template v-if="item.type === 'cascader'">
									<label>{{ item.label }}</label>
									<a-cascader
										:options="item.options"
										v-model="searchForm[item.value]"
										:placeholder="
											item.placeholder
												? item.placeholder
												: `请选择${item.label}`
										"
										v-bind="item.config"
										v-on="item.on"
									></a-cascader>
								</template>
								<template v-if="item.type === 'treeSelect'">
									<label>{{ item.label }}</label>
									<a-treeSelect
										v-model="searchForm[item.value]"
										:placeholder="
											item.placeholder
												? item.placeholder
												: `请选择${item.label}`
										"
										:treeData="item.options"
										v-bind="item.config"
										v-on="item.on"
									></a-treeSelect>
								</template>
								<template v-if="item.type === 'datePicker'">
									<label>{{ item.label }}</label>
									<a-date-picker
										v-model="searchForm[item.value]"
										:placeholder="
											item.placeholder ? item.placeholder : '选择日期时间'
										"
										v-bind="item.config"
										v-on="item.on"
									/>
								</template>
								<template v-if="item.type === 'slot'">
									<slot
										:name="item.slotName"
										v-bind="{
											searchForm,
											config: item,
										}"
									/>
								</template>
								<template v-if="item.type === 'multipleSelect'">
									<a-input-group compact>
										<label>{{ item.label }}</label>
										<a-select
											class="type"
											v-model="searchForm[item.value]['type']"
											:options="item.typeOptions"
											@change="e => changeItemType(e, item.value)"
											v-bind="item.config"
										/>
										<template v-if="searchForm[item.value]['type'] === 'IN'">
											<a-select
												mode="tags"
												allowClear
												:token-separators="[',', '\n', ' ', '，']"
												placeholder="请输入"
												v-model="searchForm[item.value]['value']"
												:maxTagCount="1"
												:maxTagTextLength="5"
											/>
										</template>
										<template
											v-else-if="
												searchForm[item.value]['type'] === 'BETWEEN' &&
												Array.isArray(searchForm[item.value]['value'])
											"
										>
											<a-input
												allowClear
												v-model.trim="searchForm[item.value]['value'][0]"
												placeholder="请输入"
											/>
											~
											<a-input
												allowClear
												v-model.trim="searchForm[item.value]['value'][1]"
												placeholder="请输入"
											/>
										</template>
										<template v-else>
											<a-input
												v-model.trim="searchForm[item.value]['value']"
												placeholder="请输入"
												allowClear
											/>
										</template>
									</a-input-group>
								</template>
							</a-form-model-item>
						</a-col>
					</template>
				</a-row>
				<div class="operation">
					<a-button type="link" icon="up" @click="closeSearchForm" class="pick">
						收起
					</a-button>
					<div style="display: flex; justify-content: flex-end; gap: 8px">
						<a-button @click="showModalPop"> 自定义 </a-button>
						<a-button type="primary" @click="getParams"> 查询 </a-button>
						<a-button @click="resetForm" class="minor-btn">重置</a-button>
					</div>
				</div>
				<div class="zidingyi" v-show="showModal">
					<div
						style="
							max-height: 200px;
							overflow: auto;
							width: 100%;
							margin-bottom: 30px;
						"
					>
						<a-checkbox-group v-model="checkedList" :options="cusSearchForm" />
					</div>
					<div
						style="
							position: absolute;
							bottom: 8px;
							right: 20px;
							vertical-align: middle;
						"
					>
						<div style="margin-left: auto">
							<yw-button
								type="primary"
								size="small"
								@click="resetCusSearchForm"
								style="background-color: #dcdcdc; color: #666; border: #dcdcdc"
							>
								取消
							</yw-button>
							<yw-button type="primary" size="small" @click="saveCusSearchForm">
								确定
							</yw-button>
						</div>
					</div>
				</div>
			</a-form-model>
		</div>
	</div>
</template>

<script>
import moment from "moment";
export default {
	name: "YwSearchGroup",
	props: {
		// 表单配置
		formOption: {
			type: Array,
			default: () => [],
		},
		minWidth: {
			type: Number,
			default: 1220,
		},
	},
	data() {
		return {
			list: [],
			searchForm: {},
			columns: 4,
			showModal: false,
			checkedList: [],
			show: false,
			defaultValue: undefined,
			visible: false,
		};
	},
	computed: {
		moment() {
			return value => moment(...value);
		},
		cusSearchForm() {
			return this.formOption.map(it => ({
				...it,
				disabled:
					this.checkedList.length === 1 && it.value === this.checkedList[0],
			}));
		},
		defaultSearch() {
			return [{ label: "", ...this.formOption.find(item => item.default) }];
		},
		containerWidth() {
			return this.minWidth ? `${this.minWidth}px` : "1220px";
		},
	},
	watch: {
		formOption: {
			handler(newVal, oldVal) {
				if (newVal?.length !== oldVal?.length) {
					this.initFormState();
				}
				if (newVal.length > 0) {
					this.list = newVal;
					this.checkedList = this.formOption.map(item => item.value);
				} else {
					this.list = [];
				}
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		handleclick() {
			this.resetForm();
		},
		getParams() {
			this.defaultValue = this.searchForm[this.defaultSearch[0].value];
			this.$emit("search", { ...this.searchForm });
			console.log(this.defaultValue);
		},
		onSearch() {
			this.defaultValue = this.searchForm[this.defaultSearch[0].value];
			this.$emit("search", { ...this.searchForm });
			console.log(this.defaultValue);
		},
		changeItemType(type, value) {
			if (type !== "BETWEEN") {
				this.$set(this.searchForm[value], "value", undefined);
			} else {
				this.$set(this.searchForm[value], "value", [undefined, undefined]);
			}
		},
		init() {
			const container = document.querySelector(".searchGroup");
			// 监听窗口大小变化
			if (container) {
				this.columns =
					document.querySelector(".searchGroup").offsetWidth > 1220 ? 4 : 3;
				window.addEventListener("resize", () => {
					this.columns = container.offsetWidth > 1220 ? 4 : 3;
				});
			}
			this.checkedList = this.formOption.map(item => item.value);
		},
		initFormState() {
			this.formOption.forEach(el => {
				if (el.type === "multipleSelect") {
					this.$set(this.searchForm, el.value, {
						type: (el.config && el.config.defaultTypeValue) || "",
						value:
							el.config &&
							el.config.defaultTypeValue &&
							el.config.defaultTypeValue === "BETWEEN"
								? [undefined, undefined]
								: undefined,
					});
				} else {
					this.$set(
						this.searchForm,
						el.value,
						(el?.config && el.config?.defaultValue) || undefined,
					);
				}
			});
		},
		resetForm() {
			this.initFormState();
			this.defaultValue = this.initFormState[this.defaultSearch[0].value];
			if (!!this.$listeners.reset) {
				this.$emit("reset", this.searchForm);
			} else {
				this.$emit("search", this.searchForm);
			}
		},
		showModalPop() {
			this.showModal = true;
		},
		closeSearchForm() {
			this.visible = false;
			this.resetCusSearchForm();
		},
		resetCusSearchForm() {
			this.checkedList = this.list.map(item => item.value);
			this.showModal = false;
		},
		saveCusSearchForm() {
			this.list = this.formOption.filter(item => {
				if (!this.checkedList.includes(item.value)) {
					item.type !== "multipleSelect"
						? this.$set(this.searchForm, item.value, undefined)
						: this.changeItemType(
								this.searchForm[item.value].value,
								item.value,
						  );
				}
				return this.checkedList.includes(item.value);
			});
			this.showModal = false;
		},
	},
	mounted() {
		this.init();
	},
};
</script>

<style lang="less" scoped>
.ant-row.ant-form-item {
	margin-bottom: 12px;
}

.searchGroup {
	margin: 0 0 12px 0;
	position: relative;
	.operationRow {
		display: flex;
		justify-content: space-between;
		gap: 8px;
		.btn-right {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			gap: 8px;
			// width: auto;
			.default-search {
				display: flex;
				width: 345px;
				align-items: center;
				top: 0;
				.ant-input-affix-wrapper,
				.ant-calendar-picker,
				.ant-cascader-picker {
					flex: 1;
				}

				.ant-input,
				.ant-select-selection,
				.ant-calendar-picker-input,
				.ant-input.ant-cascader-input {
					border-top-right-radius: 0;
					border-bottom-right-radius: 0;
				}
				.ant-btn.ant-btn-primary.ant-btn-icon-only {
					border-top-left-radius: 0;
					border-bottom-left-radius: 0;
					border-left-width: 0;
				}

				// label {
				// 	border: 1px solid #c4c6cd;
				// 	flex-shrink: 0;
				// 	border-right: 0;
				// 	border-radius: 4px;
				// 	border-top-right-radius: 0;
				// 	border-bottom-right-radius: 0;
				// 	background: #eee;
				// 	color: #666;
				// 	padding: 0 8px;
				// 	height: 32px;
				// 	line-height: 32px;
				// }
				::v-deep .ant-select[class*="type"] {
					flex: none;
					width: max-content;
					max-width: 80px;
					overflow: hidden;
					.ant-select-selection {
						border: 1px solid #c4c6cd;
						background: #eee;
						color: #666;
						box-shadow: none;
						border-radius: 0;
					}
				}
				.ant-select:not(.type) {
					flex: 1;
					max-height: 32px;
					overflow: auto;
				}
				.ant-input {
					border-radius: 0;
					flex: 1;
				}
			}
		}
		.btn-left {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			gap: 8px;
			width: auto;
		}
	}
}
.ant-modal-title {
	font-weight: bold;
}
::v-deep .searchForm {
	min-width: v-bind(containerWidth);
	margin-top: 12px;
	padding: 12px 20px;
	border-radius: 4px;
	background: var(--Gray-White, #fff);
	box-shadow: 0px 0px 0px 2px #f3f3f3 inset;
	transition: all 0.3s ease-in;
	box-sizing: border-box;
	.btnSign {
		margin: 15px 0;
	}
	.multipleSelect {
		.ant-form-item-children {
			display: block;
			.ant-input-group {
				display: flex;
				align-items: center;
				top: 0;
				.ant-select[class*="type"] {
					flex: none;
					width: max-content;
					max-width: 80px;
					overflow: hidden;
					.ant-select-selection {
						border: 1px solid #c4c6cd;
						background: #eee;
						color: #666;
						box-shadow: none;
						border-radius: 0;
					}
				}
				.ant-select:not(.type) {
					max-height: 32px;
					overflow: auto;
				}
				.ant-input {
					border-radius: 0;
					flex: 1;
				}
			}
		}
	}
	.ant-form-item {
		margin-bottom: 12px;
		.ant-form-item-children {
			display: flex;
			label {
				border: 1px solid #c4c6cd;
				flex-shrink: 0;
				border-right: 0;
				border-radius: 4px;
				border-top-right-radius: 0;
				border-bottom-right-radius: 0;
				background: #eee;
				color: #666;
				padding: 0 8px;
				height: 32px;
				line-height: 32px;
			}
			.ant-input-group-addon {
				padding: 0 8px;
			}
			.ant-select,
			.ant-calendar-picker,
			.ant-input.ant-cascader-input {
				flex: 1;
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
			}
			.ant-select-selection,
			.ant-calendar-picker-input,
			.ant-cascader-picker {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
			}
		}
	}
	.ant-input-group-wrapper {
		top: 0;
	}
}

.operation {
	display: flex;
	justify-content: flex-end;
	gap: 15px;
	.pick {
		color: #000;
		font-weight: 400;
		border: none;
		padding: 0;
		font-style: normal;
		font-family: "PingFang SC";
	}
}
.zidingyi {
	position: absolute;
	right: 20px;
	top: 100%;
	margin-top: 8px;
	margin-left: auto;
	width: 210px;
	padding: 8px;
	max-height: 250px;
	background: var(--Gray-White, #fff);
	box-shadow: 0px 3px 14px 2px rgba(0, 0, 0, 0.05),
		0px 8px 10px 1px rgba(0, 0, 0, 0.06), 0px 5px 5px -3px rgba(0, 0, 0, 0.1);
	z-index: 9990;
	::v-deep .ant-checkbox-wrapper {
		display: block;
		padding: 6px;
	}
}
</style>
